module.exports = __webpack_public_path__ + "assets/img/poster_black.2b6e8b70.png";